import { getYearMonth } from "../calendar";
import fetchJson from '../lib/react-admin-loopback/fetch';
import { stringify } from 'query-string';

export async function reqCashReceipt(yearmonth  ){

  const apiUrl = process.env.REACT_APP_API_URL;

  
  const params = {
    queryParams: JSON.stringify({
      yearMonth: getYearMonth(yearmonth) ,
      
    }),
  };
  const url = `${apiUrl}/suppliers/cashreceipt?${stringify(params)}`;

  const { json } = await fetchJson(url);
  return { 
   data : json
};
}
